<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="headertoc01" class="chapter" epub:type="toc" id="toc" role="doc-toc">
<header id="headertoc01">
<h1 class="ctbm"><span aria-label="vi" class="page" epub:type="pagebreak" id="pvi" role="doc-pagebreak"></span><span aria-label="vii" class="page" epub:type="pagebreak" id="pvii" role="doc-pagebreak"></span>Contents</h1>
</header>
<p class="tocfm" id="racknow"><a class="xref" href="#/wsutvmparksandrec0008#acknow">Acknowledgments</a></p>
<p class="tocf" id="rintro"><a class="xref" href="#/wsutvmparksandrec0009#intro">Introduction: Welcome to Pawnee</a></p>
<p class="toc" id="rch01"><a class="xref" href="#/wsutvmparksandrec0010#ch01">1. <i>Parks</i> as “Quality TV”: Legitimation of the Post-Network Sitcom</a></p>
<p class="toc" id="rch02"><a class="xref" href="#/wsutvmparksandrec0011#ch02">2. Treat Yo’ Self: Fan Culture in the Digital Age</a></p>
<p class="toc" id="rch03"><a class="xref" href="#/wsutvmparksandrec0012#ch03">3. Scenes from City Hall: Small-Town Government in the Age of Obama</a></p>
<p class="toc" id="rch04"><a class="xref" href="#/wsutvmparksandrec0013#ch04">4. Post-ing Identity: Gender and Race in <i>Parks</i></a></p>
<p class="toc" id="rconc"><a class="xref" href="#/wsutvmparksandrec0014#conc">Conclusion: Bye-Bye, Li’l Sebastian</a></p>
<p class="tocbmf" id="rrefs"><a class="xref" href="#/wsutvmparksandrec0015#refs">References</a></p>
<p class="tocbm" id="rindex"><a class="xref" href="#/wsutvmparksandrec0016#index">Index</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// wsu-tvmparksandrec-0007.vue?1e6717be